/**
 * 版本管理
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectAppVersionManagementById = (Id) => {
    return get('/api/app/appVersionManagement?CurrentId=' + Id);
}
/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddAppVersionManagement = (data) => {
    return post('/api/app/appVersionManagement', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyAppVersionManagement = (data) => {
    return put('/api/app/appVersionManagement', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataAppVersionManagementList = (data) => {
    return post('/api/app/appVersionManagement/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteAppVersionManagement = (id) => {
    return del('/api/app/appVersionManagement/' + id, {}, {});
}

/**
 * 审核
 * @param {*} data
 * @returns
 */
export const auditAppVersionManagement = (data) => {
    let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"));
    return post(`/api/app/appVersionManagement/${data.id}/audit?userName=${USER_INFO.UserName}`, {}, {});
}

/**
 * 终止
 * @param {*} data
 * @returns
 */
export const terminalAppVersionManagement = (data) => {
    let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"));
    return post(`/api/app/appVersionManagement/${data.id}/terminal?userName=${USER_INFO.UserName}`, {}, {});
}